import DatePicker, {
  ReactDatePickerCustomHeaderProps,
  DatePickerProps as ReactDatePickerProps,
} from 'react-datepicker';
import Header from 'v3/common/components/DatePicker/DateRange/Header';
import { useCallback } from 'react';
import ApplicationDomainUtility from 'v3/common/utils/applicationDomain';

const { isCrypto } = ApplicationDomainUtility;

type DateRangePickerProps = ReactDatePickerProps & {
  className?: string;
};

const DateRangePicker = ({ className, ...rest }: DateRangePickerProps) => {
  const renderCustomHeader = useCallback(
    ({
      date,
      changeYear,
      changeMonth,
      decreaseMonth,
      increaseMonth,
      prevMonthButtonDisabled,
      nextMonthButtonDisabled,
    }: ReactDatePickerCustomHeaderProps) => (
      <Header
        date={date}
        changeYear={changeYear}
        changeMonth={changeMonth}
        decreaseMonth={decreaseMonth}
        increaseMonth={increaseMonth}
        prevMonthButtonDisabled={prevMonthButtonDisabled}
        nextMonthButtonDisabled={nextMonthButtonDisabled}
      />
    ),
    []
  );

  return (
    <div className={className}>
      <DatePicker
        {...rest}
        inline
        filterDate={(date) => isCrypto || (date.getDay() !== 0 && date.getDay() !== 6)} // disables weekends unless isCrypto
        renderCustomHeader={renderCustomHeader}
      />
    </div>
  );
};

export default DateRangePicker;
